/**
 * JSON格式化工具类
 * 提供格式化JSON字符串的功能，以美化格式显示
 */
const JSONFormatter = {
  format(jsonStr) {
    try {
      const jsonObj = JSON.parse(jsonStr);
      const formattedContent = this.formatObject(jsonObj, 0);
      return `<div class="json-formatter">${formattedContent}</div>`;
    } catch (e) {
      console.error("JSON parse error:", e);
      return `<pre class="json-formatter-error">${jsonStr}</pre>`;
    }
  },

  formatObject(obj, level) {
    if (obj === null) return '<span class="json-formatter-null">null</span>';

    switch (typeof obj) {
      case "undefined":
        return '<span class="json-formatter-undefined">undefined</span>';
      case "boolean":
        return `<span class="json-formatter-boolean">${obj}</span>`;
      case "number":
        return `<span class="json-formatter-number">${obj}</span>`;
      case "string":
        return `<span class="json-formatter-string">"${this.escapeHTML(
          obj
        )}"</span>`;
      case "object":
        if (Array.isArray(obj)) {
          return this.formatArray(obj, level);
        } else {
          return this.formatObjectLiteral(obj, level);
        }
      default:
        return String(obj);
    }
  },

  formatArray(arr, level) {
    if (arr.length === 0) return "[]";

    const isComplex = this.isComplexArray(arr);
    const collapsible = isComplex && level < 10; // 限制嵌套层级，避免过度复杂
    const indent = " ".repeat((level + 1) * 2);
    const closingIndent = " ".repeat(level * 2);

    let content = arr
      .map((item) => `${indent}${this.formatObject(item, level + 1)}`)
      .join(",<br/>");

    const uniqueId = `json-array-${Math.random().toString(36).substr(2, 9)}`;

    if (collapsible) {
      return `<div class="json-formatter-collapsible"><span class="json-formatter-toggle" onclick="toggleJsonCollapse('${uniqueId}')">▼</span><span class="json-formatter-bracket">[</span><div id="${uniqueId}" class="json-formatter-content">${content}</div><span class="json-formatter-bracket">]</span></div>`;
    } else {
      return `[${content}]`;
    }
  },

  formatObjectLiteral(obj, level) {
    const keys = Object.keys(obj);
    if (keys.length === 0) return "{}";

    const isComplex = this.isComplexObject(obj);
    const collapsible = isComplex && level < 10; // 限制嵌套层级，避免过度复杂
    const indent = " ".repeat((level + 1) * 2);
    const closingIndent = " ".repeat(level * 2);

    let content = keys
      .map(
        (key) =>
          `${indent}<span class="json-formatter-key">"${this.escapeHTML(
            key
          )}"</span>: ${this.formatObject(obj[key], level + 1)}`
      )
      .join(",<br/>");

    const uniqueId = `json-obj-${Math.random().toString(36).substr(2, 9)}`;

    if (collapsible) {
      return `<div class="json-formatter-collapsible"><span class="json-formatter-toggle" onclick="toggleJsonCollapse('${uniqueId}')">▼</span><span class="json-formatter-bracket">{</span><div id="${uniqueId}" class="json-formatter-content">${content}</div><span class="json-formatter-bracket">}</span></div>`;
    } else {
      return `{${content}}`;
    }
  },

  isComplexArray(arr) {
    // 如果数组长度超过3或包含对象/数组，则认为是复杂数组
    return (
      arr.length > 3 ||
      arr.some((item) => typeof item === "object" && item !== null)
    );
  },

  isComplexObject(obj) {
    // 如果对象属性超过3个或包含嵌套对象/数组，则认为是复杂对象
    const keys = Object.keys(obj);
    return (
      keys.length > 3 ||
      keys.some((key) => typeof obj[key] === "object" && obj[key] !== null)
    );
  },

  escapeHTML(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  },
};

export default JSONFormatter;
